import React from 'react'
import { withSiteData } from 'react-static'

export default withSiteData(() => (
  <div style={{ textAlign: 'center' }}>
    <h1>Welcome to React-Static</h1>
  </div>
))
